// extracted by mini-css-extract-plugin
export default {"container":"color-picker_container__JD3KV","color":"color-picker_color__K7E3C","selected":"color-picker_selected__JlnBe"};